import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';

/**
Display a Progress Bar Indicator item
**/
export default class ProgressBar extends React.Component {
  static displayName = 'ProgressBar';
  static propTypes = {
    /** The child content to render in the progress bar. */
    children: PropTypes.node,
    /** The current progress value. */
    digit: PropTypes.number,
    /** The completed progress value. */
    total: PropTypes.number,
    /** Flag indicating whether the operation was successful. */
    success: PropTypes.bool,
    /** Available Style Keys. */
    style: PropTypes.shape({
      /** Top level style applied to the container. */
      container: PropTypes.object,
      /** Style applied to the indicator. */
      indicator: PropTypes.object,
      /** Style applied to the bar. */
      bar: PropTypes.object,
      /** Additional style applied to the bar if the success flag is set. */
      successBar: PropTypes.object,
      /** Style applied to the wrapper around the child content. */
      message: PropTypes.object
    })
  };
  render() {
    let counterDigit = this.props.digit;
    while (counterDigit > this.props.total) {
      counterDigit = counterDigit - this.props.total; // Mostly used for days; prevent counter from looking wrong
    }
    const barStyle = {
      width: Math.floor((counterDigit / this.props.total) * 100) + '%',
      ...resolve(this.props, 'bar', this.props.success ? 'successBar' : null).style
    };
    return (
      <div {...resolve(this.props, 'container')}>
        <div {...resolve(this.props, 'indicator')}>
          <div {...resolve(this.props, 'bar', this.props.success ? 'successBar' : null)} style={barStyle} />
          <div {...resolve(this.props, 'message')}>
            {this.props.children ? this.props.children : null}
          </div>
        </div>
      </div>
    );
  }
}
